<div class="cta-section">
  <h2>{{ title() }}</h2>
  @if (description()) {
    <p>{{ description() }}</p>
  }
  <ng-content></ng-content>
</div>
